import { Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-deactivation-warning',
  standalone: false,
  templateUrl: './deactivation-warning.component.html',
  styleUrl: './deactivation-warning.component.scss'
})
export class DeactivationWarningComponent {
  constructor(private dialogRef: NzModalRef<DeactivationWarningComponent>) { }

  public onCloseModal(): void {
    this.dialogRef.close(false);
  }

  public onConfirm(): void {
    this.dialogRef.close(true);
  }
}
